import { Navigate } from 'react-router'
import { ROUTES } from '../../routes/routeConfig'
import {getAccessToken,getForcePasswordReset,getMfaEnabled,getItAdmin} from "../../utils/session"

const AuthGuard = ({ children }) => {
   const token = getAccessToken()
  const forcePasswordReset = getForcePasswordReset()
  const mfaEnabled = getMfaEnabled()
  const itAdmin = getItAdmin()

  // Fully authenticated if:
  // - has token
  // - not forced to reset password
  // - MFA enabled OR user is IT Admin
  const isFullyAuthenticated = token && !forcePasswordReset && (mfaEnabled || itAdmin)

  if (isFullyAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  return children
}

export default AuthGuard
